import {API_URLS} from '@/const';
import {http} from '@/helper';

export const bonusApi = {
  getWelcomeConfig() {
    return http.get(API_URLS.BONUS_WELCOME_CONFIG, {});
  },
  getTaskList(query) {
    return http.get(API_URLS.BONUS_TASK_LIST, {query});
  },
  async postPrivilegeLottery(params) {
    const {data, error} = await http.post(API_URLS.BONUS_PRIVILEGE_LOTTERY, {params});
    if (error) {
      return {rows: null, error: error};
    }
    const details = await http.get(API_URLS.BONUS_PRIVILEGE_DETAILS, {query: {channel: 'WEB', scene: 'WELCOME_BONUS', list: data.privilegeIdList}});
    return {rows: details?.data?.rows, error: details?.error};
  },
};
